export default new (class BurgerMenu {
    constructor() {
        this.currentDropdown = null
        this.currentDropdownSelect = null

        this.sMenuClass = "_burger"
        this.sMenuContentClass = "_burger-content"
        this.sButtonMenuClass = "_burger-btn-open"

        this.sMenuSelectClass = "_burger-select"
        this.sMenuSelectTitleClass = "_burger-select-title"
        this.sMenuSelectBtnClass = "_burger-select-btn"
        this.sMenuSelectContentClass = "_burger-select-content"

        this.parameters = {
            duration: 500,
        }

        this.initHandler()
        this.initJqAnimate()
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        //burder click
        if(window.innerWidth < 1200) {
            document.querySelectorAll('.' + this.sButtonMenuClass).forEach((item) => {
                item.addEventListener('click', (obEvent) => {
                    this.burgerMenuToggle(obEvent)
                    if (obEvent.target.closest('.' + this.sMenuClass).querySelector('.' + this.sButtonMenuClass+ ' img').classList.contains("scale-1")) {
                        this.currentDropdown = obEvent.target.closest('.' + this.sMenuClass);
                    } else {
                        this.currentDropdown = null;
                    }
                });
            });
        }

        //select click
        document.querySelectorAll('.' + this.sMenuSelectBtnClass).forEach((item) => {
            item.addEventListener('click', (obEvent) => {
                obEvent.preventDefault()
                this.selectMenuToggle(obEvent);
                if (obEvent.target.closest('.' + this.sMenuSelectClass).querySelector('.' + this.sMenuSelectTitleClass+ ' div').classList.contains("font-semibold")) {
                    this.currentDropdownSelect = obEvent.target.closest('.' + this.sMenuSelectClass);
                } else {
                    this.currentDropdownSelect = null;
                }
            });
        });

        //закрытие при нажатии на пустоту
        document.addEventListener('click', (e) => {
            if (this.currentDropdown && e.target !== this.currentDropdown && (e.target).closest('.' + this.sMenuClass) == null) {
                this.burgerMenuClose();
            }
            if (this.currentDropdownSelect && e.target !== this.currentDropdownSelect && (e.target).closest('.' + this.sMenuSelectClass) == null) {
                this.selectMenuToggle();
            }
        });
    }

    initJqAnimate() {
        HTMLDivElement.prototype.slideUp = function(parameters , element = null)
        {
            if(!element) {
                element = this;
            }
            element.style.transitionProperty = 'height, margin, padding';
            element.style.transitionDuration = parameters.duration + 'ms';
            element.style.boxSizing = 'border-box';
            element.style.height = element.offsetHeight + 'px';
            element.offsetHeight;
            element.style.overflow = 'hidden';
            element.style.height = 0;
            element.style.paddingTop = 0;
            element.style.paddingBottom = 0;
            element.style.marginTop = 0;
            element.style.marginBottom = 0;
            window.setTimeout( () => {
                element.style.display = 'none';
                element.style.removeProperty('height');
                element.style.removeProperty('padding-top');
                element.style.removeProperty('padding-bottom');
                element.style.removeProperty('margin-top');
                element.style.removeProperty('margin-bottom');
                element.style.removeProperty('overflow');
                element.style.removeProperty('transition-duration');
                element.style.removeProperty('transition-property');
            }, parameters.duration);
        }
        HTMLDivElement.prototype.slideDown = function(parameters, element = null)
        {
            if(!element) {
                element = this;
            }
            element.style.removeProperty('display');
            let display = window.getComputedStyle(element).display;

            if (display === 'none')
                display = 'block';

            element.style.display = display;
            let height = element.offsetHeight;
            element.style.overflow = 'hidden';
            element.style.height = 0;
            element.style.paddingTop = 0;
            element.style.paddingBottom = 0;
            element.style.marginTop = 0;
            element.style.marginBottom = 0;
            element.offsetHeight;
            element.style.boxSizing = 'border-box';
            element.style.transitionProperty = "height, margin, padding";
            element.style.transitionDuration = parameters.duration + 'ms';
            element.style.height = height + 'px';
            element.style.removeProperty('padding-top');
            element.style.removeProperty('padding-bottom');
            element.style.removeProperty('margin-top');
            element.style.removeProperty('margin-bottom');
            window.setTimeout( () => {
                element.style.removeProperty('height');
                element.style.removeProperty('overflow');
                element.style.removeProperty('transition-duration');
                element.style.removeProperty('transition-property');
            }, parameters.duration);
        }
        HTMLDivElement.prototype.slideToggle = function(parameters){
            if (window.getComputedStyle(this).display === 'none') {
                this.slideDown(parameters, this);
            } else {
                this.slideUp(parameters, this);
            }
        }
    }

    burgerMenuToggle(obEvent) {
        obEvent.preventDefault()

        if (obEvent.target.closest('[data-burger="catalog"]') == null) {
            obEvent.target.closest('.' + this.sMenuClass).querySelector('.' + this.sButtonMenuClass).classList.toggle("bg-white")
        }
        let _sMenuContentClass = this.sMenuContentClass
        let _sButtonMenuClass = this.sButtonMenuClass
        let _sMenuClass = this.sMenuClass
        document.querySelectorAll('.' + this.sMenuClass).forEach(function (element, index) {
            if (obEvent.target.closest('.' + _sMenuClass) != element) {
                element.querySelector('.' + _sMenuContentClass).classList.add("opacity-0")
                element.querySelector('.' + _sMenuContentClass).classList.add("invisible")
                element.querySelector('.' + _sMenuContentClass).classList.remove("opacity-100")
                element.querySelector('.' + _sMenuContentClass).classList.remove("visible")
                if (element.getAttribute("data-burger") == "catalog") {
                    element.querySelector('.' + _sButtonMenuClass+' img').classList.add("scale-[-1]")
                    element.querySelector('.' + _sButtonMenuClass+' img').classList.remove("scale-1")

                    element.classList.remove("lg:before:opacity-100")
                    element.classList.remove("lg:before:visible")
                    element.classList.add("lg:before:invisible")
                    element.classList.add("lg:before:opacity-0")
                }

                if (element.getAttribute("data-burger") !== "catalog") {
                    element.querySelector('.' + _sButtonMenuClass).classList.remove("bg-white")
                }
            }
        })

        if (obEvent.target.closest('.' + this.sMenuClass).getAttribute("data-burger") == "catalog") {
            obEvent.target.closest('.' + this.sMenuClass).classList.toggle("lg:before:opacity-100")
            obEvent.target.closest('.' + this.sMenuClass).classList.toggle("lg:before:visible")
            obEvent.target.closest('.' + this.sMenuClass).classList.toggle("lg:before:invisible")
            obEvent.target.closest('.' + this.sMenuClass).classList.toggle("lg:before:opacity-0")
        }

        obEvent.target.closest('.' + this.sMenuClass).querySelector('.' + this.sMenuContentClass).classList.toggle("opacity-0")
        obEvent.target.closest('.' + this.sMenuClass).querySelector('.' + this.sMenuContentClass).classList.toggle("invisible")
        obEvent.target.closest('.' + this.sMenuClass).querySelector('.' + this.sMenuContentClass).classList.toggle("opacity-100")
        obEvent.target.closest('.' + this.sMenuClass).querySelector('.' + this.sMenuContentClass).classList.toggle("visible")

        obEvent.target.closest('.' + this.sMenuClass).querySelector('.' + this.sButtonMenuClass+' img').classList.toggle("scale-[-1]")
        obEvent.target.closest('.' + this.sMenuClass).querySelector('.' + this.sButtonMenuClass+' img').classList.toggle("scale-1")
    }

    burgerMenuClose() {
        this.currentDropdown = null;

        let _sMenuContentClass = this.sMenuContentClass
        let _sButtonMenuClass = this.sButtonMenuClass
        document.querySelectorAll('.' + this.sMenuClass).forEach(function (element, index) {
            element.querySelector('.' + _sMenuContentClass).classList.add("opacity-0")
            element.querySelector('.' + _sMenuContentClass).classList.add("invisible")
            element.querySelector('.' + _sMenuContentClass).classList.remove("opacity-100")
            element.querySelector('.' + _sMenuContentClass).classList.remove("visible")
            if (element.getAttribute("data-burger") == "catalog") {
                element.querySelector('.' + _sButtonMenuClass+' img').classList.add("scale-[-1]")
                element.querySelector('.' + _sButtonMenuClass+' img').classList.remove("scale-1")

                element.classList.remove("lg:before:opacity-100")
                element.classList.remove("lg:before:visible")
                element.classList.add("lg:before:invisible")
                element.classList.add("lg:before:opacity-0")
            }

            if (element.getAttribute("data-burger") !== "catalog") {
                element.querySelector('.' + _sButtonMenuClass).classList.remove("bg-white")
            }
        })
    }

    selectMenuToggle(obEvent = null) {
        if(obEvent) {
            let sMenuSelectContentClass = this.sMenuSelectContentClass
            let sMenuSelectTitleClass = this.sMenuSelectTitleClass
            let sMenuSelectBtnClass = this.sMenuSelectBtnClass
            let parameters = this.parameters
            document.querySelectorAll('[data-burger-select="filter"] .'+this.sMenuSelectBtnClass).forEach(function (element, index) {
                if (obEvent.target.closest('.'+sMenuSelectBtnClass) != element) {
                    element.closest('[data-burger-select="filter"]').querySelector('.' + sMenuSelectTitleClass+' div').classList.remove("text-blue")
                    element.closest('[data-burger-select="filter"]').querySelector('.' + sMenuSelectTitleClass+' div').classList.remove("font-semibold")
                    element.closest('[data-burger-select="filter"]').querySelector('.' + sMenuSelectTitleClass+' svg path').classList.remove("fill-blue")
                    element.closest('[data-burger-select="filter"]').querySelector('.' + sMenuSelectTitleClass+' svg path').classList.add("fill-black-light")
                    element.closest('[data-burger-select="filter"]').querySelector('.' + sMenuSelectTitleClass+' svg').classList.remove("scale-[-1]")
                    element.closest('[data-burger-select="filter"]').querySelector('.' + sMenuSelectTitleClass+' svg').classList.add("scale-1")
                    element.closest('[data-burger-select="filter"]').querySelector('.' + sMenuSelectContentClass).slideUp(parameters)
                }
            })



            if (obEvent.target.closest('main [data-burger="catalog"]') || !obEvent.target.closest('.'+this.sMenuClass)) {
                obEvent.target.closest('.' + this.sMenuSelectClass).firstChild.classList.toggle("font-bold")
            }
            obEvent.target.closest('.' + this.sMenuSelectClass).querySelector('.' + this.sMenuSelectContentClass).slideToggle(this.parameters)

            if (obEvent.target.closest('[data-burger-select="filter"]') == null) {
                obEvent.target.classList.toggle("scale-[-1]")
                obEvent.target.classList.toggle("scale-1")
            } else {
                obEvent.target.closest('[data-burger-select="filter"]').querySelector('.' + this.sMenuSelectTitleClass+' div').classList.toggle("text-blue")
                obEvent.target.closest('[data-burger-select="filter"]').querySelector('.' + this.sMenuSelectTitleClass+' div').classList.toggle("font-semibold")
                obEvent.target.closest('[data-burger-select="filter"]').querySelector('.' + this.sMenuSelectTitleClass+' svg path').classList.toggle("fill-black-light")
                obEvent.target.closest('[data-burger-select="filter"]').querySelector('.' + this.sMenuSelectTitleClass+' svg path').classList.toggle("fill-blue")
                obEvent.target.closest('[data-burger-select="filter"]').querySelector('.' + this.sMenuSelectTitleClass+' svg').classList.toggle("scale-[-1]")
            }
        }
        else {
            let sMenuSelectContentClass = this.sMenuSelectContentClass
            let sMenuSelectTitleClass = this.sMenuSelectTitleClass
            let parameters = this.parameters
            document.querySelectorAll('[data-burger-select="filter"] .'+this.sMenuSelectBtnClass).forEach(function (element, index) {
                element.closest('[data-burger-select="filter"]').querySelector('.' + sMenuSelectTitleClass+' div').classList.remove("text-blue")
                element.closest('[data-burger-select="filter"]').querySelector('.' + sMenuSelectTitleClass+' div').classList.remove("font-semibold")
                element.closest('[data-burger-select="filter"]').querySelector('.' + sMenuSelectTitleClass+' svg path').classList.remove("fill-blue")
                element.closest('[data-burger-select="filter"]').querySelector('.' + sMenuSelectTitleClass+' svg path').classList.add("fill-black-light")
                element.closest('[data-burger-select="filter"]').querySelector('.' + sMenuSelectTitleClass+' svg').classList.remove("scale-[-1]")
                element.closest('[data-burger-select="filter"]').querySelector('.' + sMenuSelectTitleClass+' svg').classList.add("scale-1")
                element.closest('[data-burger-select="filter"]').querySelector('.' + sMenuSelectContentClass).slideUp(parameters)
            })
        }
    }
})()